const React = require('react');
const withState = require('../../../../utils/withState');
const WrapperWithLoading = require('../../../dumb/WrapperWithLoading/B');
const {
  replaceLocation,
} = require('../../../../router');
const {
  LINK_SIGN_IN,
} = require('../../../../constants/links');
const {
  account$,
} = require('../../../../emitters/account');


module.exports = withState((setState, self, onMount) => {
  return (state, props) => {
    const params = props.params || {};
    const token = params.token;


    token && account$.emailConfirm({
      skipError: 1,
      code: token,
    }).finally(() => {
      replaceLocation({
        path: LINK_SIGN_IN,
      });
    });

    return (
      <WrapperWithLoading
        className="h100vh"
        loading
      />
    );
  };
}, {});
